angular.module('gym.waivers').factory('LoadDebouncedWaiverReviewsPendingCountService', ["$q", "WaiverReviews", function($q, WaiverReviews) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    return WaiverReviews.get('pending_count').then(function(data) {
      return deferred.resolve(data);
    }, function(data) {
      return deferred.reject(data);
    });
  }), 1000);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);
